export const MEDIARELATION ='MEDIARELATION';
export const BLOG ='BLOG';
export const BLOGDETAILS ='BLOGDETAILS';
